import React, {useEffect, useState} from 'react';
import {useLocation, useParams} from "react-router-dom";
import {ArrowLeft, ArrowRight, ArrowRightFull} from "../../icons/icons";
import {useTranslation} from "react-i18next";
import useDirection from "../../hooks/useDirection";

const Broadcast = () => {
  const pathname = useLocation().pathname
  const { t } = useTranslation();
  const directionClass = useDirection();

  const [activeRoute , setActiveRoute] = useState({})
   const list = [
    {route:"/basic-information/state" ,title:"basicInformation/state" , link:"basic-information"},
    {route:"/basic-information/city" ,title:"basicInformation/city" , link:"basic-information"},
    {route:"/basic-information/ship" ,title:"basicInformation/ship" , link:"basic-information"},
    {route:"/basic-information/wharf" ,title:"basicInformation/wharf" , link:"basic-information"},
    {route:"/basic-information/visa" ,title:"basicInformation/visa" , link:"basic-information"},
    {route:"/basic-information/jobs" ,title:"basicInformation/job" , link:"basic-information"},
    {route:"/basic-information/role" ,title:"basicInformation/role" , link:"basic-information"},
    {route:"/basic-information/users" ,title:"basicInformation/users" , link:"basic-information"},
    {route:"/basic-information/user/new" ,title:"basicInformation/user/new" , link:"basic-information"},
    {route:"/basic-information/airport" ,title:"basicInformation/airport" , link:"basic-information"},
    {route:"/basic-information/airline" ,title:"basicInformation/airline" , link:"basic-information"},
    {route:"/basic-information/emails" ,title:"basicInformation/emails" , link:"basic-information"},
    {route:"/basic-information/country" ,title:"basicInformation/country" , link:"basic-information"},
    {route:"/basic-information/job-levels" ,title:"basicInformation/jobLevels" , link:"basic-information"},
    {route:"/basic-information/ship-type" ,title:"basicInformation/shipType" , link:"basic-information"},
    {route:"/setting" ,title:"setting" , link:"setting"},
    {route:"/transactions" ,title:"transactions" , link:"transactions"},
    {route:"/visa-orders" ,title:"visaOrders" , link:"visaOrders"},
    {route:"/visa-orders/new-visa" ,title:"visaOrders/newVisaOrder" , link:"newVisaOrder"},
    {route:"/crew" ,title:"crew" , link:"crew"},
    {route:"/crew/visa-history" ,title:"crew/visaHistory" , link:"/crew/visa-history"},
    {route:"/crew/new-crew" ,title:"crew/newCrew" , link:"/crew/new-crew"},
    {route:"/profile" ,title:"userProfile" , link:"profile"},
    {route:"/reports/unpaid" ,title:"unpaid_reports" , link:"profile"},
    {route:"/active-visas" ,title:"activeVisas" , link:"dashboard"},
  ]
  useEffect(() => {
   const findRoute = list?.find((item) => {
      return item.route === pathname
    })
     setActiveRoute(findRoute)
  } ,[pathname])

  const handleRoute = () => {
    const splitRoute = activeRoute?.title?.split("/")
    console.log(splitRoute)
     return splitRoute?.map((item , index) => {
       return(
        <div className={"flex items-center "}>
          <span className={"text-xs md:text-[18px] text-gray-500"}>{t(item)}</span>
          {
            index !== splitRoute?.length - 1 ?
              directionClass ?
                <ArrowLeft/>
                :
                <ArrowRightFull/>
              :
              ""
          }

        </div>
      )
    })
  }

  return (
    <div className={`flex items-center ${directionClass ? "mr-10" : "ml-10"} md:ml-0 md:mr-0`}>
      {handleRoute()}
    </div>
  );
};

export default Broadcast;
